module.exports = __webpack_public_path__ + "static/img/lu.0d040ab2.svg";